export class Notification {


    
    public message:string;
    public migrationId:string;
  
 
 

    public   userEmail :string;
    
    public   timeCreated  : Date;

    public   notificationCleared  : boolean;
    
    public   notificationType : number;
    public  static readonly  notificationTypeCount:number= 5;

    
    
    
    public static readonly  NEW_ORDER=0;
    public static readonly    ERROR=1 ;
    public static readonly   REMINDER=2; 
    public static readonly    HELP_REQUEST=3 ;
    public  static readonly   CLEAR=4 ;
    
      
        public    id  : string;

   



    
}


// WEBPACK FOOTER //
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/src/app/layout/notifications-page/notification.ts